"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeClosePerpetual = exports.computeOpenPerpetualFromMarginPosition = exports.computeOpenPerpetualLeveragePosition = exports.computeOpenPerpetualFromMarginLeverage = void 0;
const ethers_1 = require("ethers");
const constants_1 = __importDefault(require("../constants"));
const bignumber_1 = require("../utils/bignumber");
const spread_1 = require("./spread");
function computeOpenPerpetualFromMarginLeverage(chainID, stableSymbol, collateralSymbol, margin, leverage, inDecimals, totalCoveredAmount, stocksUsers, rate = 0, targetHAHedge = ethers_1.BigNumber.from(0), haBonusMalusDeposit = ethers_1.BigNumber.from(0), _xHAFeesDeposit = [ethers_1.BigNumber.from(0)], _yHAFeesDeposit = [ethers_1.BigNumber.from(0)], iterations = 10) {
    margin = ethers_1.BigNumber.from(margin);
    leverage = ethers_1.BigNumber.from(leverage);
    totalCoveredAmount = ethers_1.BigNumber.from(totalCoveredAmount);
    targetHAHedge = ethers_1.BigNumber.from(targetHAHedge);
    const xHAFeesDeposit = _xHAFeesDeposit.map((e) => ethers_1.BigNumber.from(e));
    const yHAFeesDeposit = _yHAFeesDeposit.map((e) => ethers_1.BigNumber.from(e));
    haBonusMalusDeposit = ethers_1.BigNumber.from(haBonusMalusDeposit);
    stocksUsers = ethers_1.BigNumber.from(stocksUsers);
    rate = ethers_1.BigNumber.from(rate);
    const inBase = (0, bignumber_1.multByPow)(1, inDecimals);
    let netMargin = margin;
    let positionSize = leverage.mul(netMargin).div((0, constants_1.default)(chainID).BASE_TOKENS).sub(netMargin);
    let percentageFee = ethers_1.BigNumber.from(0);
    let fees = ethers_1.BigNumber.from(0);
    for (let i = 0; i < iterations; i++) {
        const hedgeRatio = (0, spread_1.computeHedgeRatio)(totalCoveredAmount.add(positionSize.mul(rate).div(inBase)), targetHAHedge, stocksUsers);
        percentageFee = haBonusMalusDeposit.mul((0, bignumber_1.piecewiseFunction)(hedgeRatio, xHAFeesDeposit, yHAFeesDeposit)).div((0, bignumber_1.gwei)(1));
        fees = positionSize.mul(percentageFee).div((0, bignumber_1.gwei)(1));
        netMargin = margin.sub(fees);
        positionSize = leverage.mul(netMargin).div((0, constants_1.default)(chainID).BASE_TOKENS).sub(netMargin);
    }
    return {
        percentageFee,
        fees,
        positionSize,
    };
}
exports.computeOpenPerpetualFromMarginLeverage = computeOpenPerpetualFromMarginLeverage;
function computeOpenPerpetualLeveragePosition(chainID, stableSymbol, collateralSymbol, leverage, positionSize, inDecimals, totalCoveredAmount, stocksUsers, rate = 0, targetHAHedge = ethers_1.BigNumber.from(0), haBonusMalusDeposit = ethers_1.BigNumber.from(0), _xHAFeesDeposit = [ethers_1.BigNumber.from(0)], _yHAFeesDeposit = [ethers_1.BigNumber.from(0)]) {
    leverage = ethers_1.BigNumber.from(leverage);
    positionSize = ethers_1.BigNumber.from(positionSize);
    totalCoveredAmount = ethers_1.BigNumber.from(totalCoveredAmount);
    targetHAHedge = ethers_1.BigNumber.from(targetHAHedge);
    const xHAFeesDeposit = _xHAFeesDeposit.map((e) => ethers_1.BigNumber.from(e));
    const yHAFeesDeposit = _yHAFeesDeposit.map((e) => ethers_1.BigNumber.from(e));
    haBonusMalusDeposit = ethers_1.BigNumber.from(haBonusMalusDeposit);
    stocksUsers = ethers_1.BigNumber.from(stocksUsers);
    rate = ethers_1.BigNumber.from(rate);
    const inBase = (0, bignumber_1.multByPow)(1, inDecimals);
    const netMargin = positionSize.mul((0, constants_1.default)(chainID).BASE_TOKENS).div(leverage.sub((0, constants_1.default)(chainID).BASE_TOKENS));
    const hedgeRatio = (0, spread_1.computeHedgeRatio)(totalCoveredAmount.add(positionSize.mul(rate).div(inBase)), targetHAHedge, stocksUsers);
    const percentageFee = haBonusMalusDeposit.mul((0, bignumber_1.piecewiseFunction)(hedgeRatio, xHAFeesDeposit, yHAFeesDeposit)).div((0, bignumber_1.gwei)(1));
    const fees = positionSize.sub(positionSize.mul((0, constants_1.default)(chainID).BASE_PARAMS.sub(percentageFee)).div((0, constants_1.default)(chainID).BASE_PARAMS));
    const margin = netMargin.add(fees);
    return {
        percentageFee,
        fees,
        margin,
    };
}
exports.computeOpenPerpetualLeveragePosition = computeOpenPerpetualLeveragePosition;
function computeOpenPerpetualFromMarginPosition(chainID, stableSymbol, collateralSymbol, margin, positionSize, inDecimals, totalCoveredAmount, stocksUsers, rate = 0, targetHAHedge = ethers_1.BigNumber.from(0), haBonusMalusDeposit = ethers_1.BigNumber.from(0), _xHAFeesDeposit = [ethers_1.BigNumber.from(0)], _yHAFeesDeposit = [ethers_1.BigNumber.from(0)]) {
    margin = ethers_1.BigNumber.from(margin);
    positionSize = ethers_1.BigNumber.from(positionSize);
    totalCoveredAmount = ethers_1.BigNumber.from(totalCoveredAmount);
    targetHAHedge = ethers_1.BigNumber.from(targetHAHedge);
    const xHAFeesDeposit = _xHAFeesDeposit.map((e) => ethers_1.BigNumber.from(e));
    const yHAFeesDeposit = _yHAFeesDeposit.map((e) => ethers_1.BigNumber.from(e));
    haBonusMalusDeposit = ethers_1.BigNumber.from(haBonusMalusDeposit);
    stocksUsers = ethers_1.BigNumber.from(stocksUsers);
    rate = ethers_1.BigNumber.from(rate);
    const inBase = (0, bignumber_1.multByPow)(1, inDecimals);
    const hedgeRatio = (0, spread_1.computeHedgeRatio)(totalCoveredAmount.add(positionSize.mul(rate).div(inBase)), targetHAHedge, stocksUsers);
    const percentageFee = haBonusMalusDeposit.mul((0, bignumber_1.piecewiseFunction)(hedgeRatio, xHAFeesDeposit, yHAFeesDeposit)).div((0, bignumber_1.gwei)(1));
    const fees = positionSize.sub(positionSize.mul((0, constants_1.default)(chainID).BASE_PARAMS.sub(percentageFee)).div((0, constants_1.default)(chainID).BASE_PARAMS));
    const netMargin = margin.sub(fees);
    const leverage = positionSize.add(netMargin).mul((0, constants_1.default)(chainID).BASE_TOKENS).div(netMargin);
    return {
        percentageFee,
        fees,
        leverage,
    };
}
exports.computeOpenPerpetualFromMarginPosition = computeOpenPerpetualFromMarginPosition;
function computeClosePerpetual(chainID, stableSymbol, collateralSymbol, margin, positionSize, entryRate, currentRate = 0, inDecimals, totalCoveredAmount, stocksUsers, maintenanceMargin, targetHAHedge = ethers_1.BigNumber.from(0), haBonusMalusWithdraw = (0, bignumber_1.gwei)(1), _xHAFeesWithdraw = [ethers_1.BigNumber.from(0)], _yHAFeesWithdraw = [ethers_1.BigNumber.from(0)]) {
    margin = ethers_1.BigNumber.from(margin);
    positionSize = ethers_1.BigNumber.from(positionSize);
    totalCoveredAmount = ethers_1.BigNumber.from(totalCoveredAmount);
    targetHAHedge = ethers_1.BigNumber.from(targetHAHedge);
    maintenanceMargin = ethers_1.BigNumber.from(maintenanceMargin);
    const xHAFeesWithdraw = _xHAFeesWithdraw.map((e) => ethers_1.BigNumber.from(e));
    const yHAFeesWithdraw = _yHAFeesWithdraw.map((e) => ethers_1.BigNumber.from(e));
    haBonusMalusWithdraw = ethers_1.BigNumber.from(haBonusMalusWithdraw);
    stocksUsers = ethers_1.BigNumber.from(stocksUsers);
    entryRate = ethers_1.BigNumber.from(entryRate);
    currentRate = ethers_1.BigNumber.from(currentRate);
    const inBase = (0, bignumber_1.multByPow)(1, inDecimals);
    if (margin.isNegative() || positionSize.isNegative()) {
        throw Error('Invalid arguments');
    }
    if (currentRate === null || currentRate === void 0 ? void 0 : currentRate.eq(0)) {
        return undefined;
    }
    const newCommit = positionSize.mul(entryRate).div(currentRate);
    let cashOutAmount = newCommit.gte(positionSize.add(margin)) ? (0, bignumber_1.ether)(0) : positionSize.add(margin).sub(newCommit);
    const liquidable = cashOutAmount.mul((0, bignumber_1.gwei)(1)).lte(positionSize.mul(maintenanceMargin));
    const hedgeRatio = (0, spread_1.computeHedgeRatio)(totalCoveredAmount.sub(positionSize.mul(entryRate).div(inBase)), targetHAHedge, stocksUsers);
    const percentageFee = haBonusMalusWithdraw.mul((0, bignumber_1.piecewiseFunction)(hedgeRatio, xHAFeesWithdraw, yHAFeesWithdraw)).div((0, bignumber_1.gwei)(1));
    const fees = positionSize.mul(percentageFee).div((0, bignumber_1.gwei)(1));
    cashOutAmount = cashOutAmount.sub(fees);
    return {
        cashOutAmount: cashOutAmount,
        fees,
        liquidable,
    };
}
exports.computeClosePerpetual = computeClosePerpetual;
//# sourceMappingURL=ha.js.map